import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({ selector: '[growOnFocus]' })
export class GrowOnFocusDirective {
    @HostBinding('style.width.px')
    width: number = 120;

    constructor() {}

    @HostListener('focus')
    onFocus() {
        this.width = 500;
    }

    @HostListener('blur')
    onBlur() {
        this.width = 120;
    }
}
